module.exports = "<header class=\"header\">\n  <div\n    routerLink=\"/home\"\n    (click)=\"router.navigate(['home'])\"\n    [routerLinkActive]=\"['is-active']\">\n    <clr-icon shape=\"home\" size=\"36\"></clr-icon>\n  </div>\n  <div routerLink=\"/overview\"\n       (click)=\"router.navigate(['overview'])\"\n       [routerLinkActive]=\"['is-active']\">Artikelübersicht\n  </div>\n  <div routerLink=\"/user\"\n       (click)=\"router.navigate(['user'])\"\n       [routerLinkActive]=\"['is-active']\">Benutzer\n  </div>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation/navigation.component.html
// module id = 395
// module chunks = 1